import { render, staticRenderFns } from "./AddEditQualityReport.vue?vue&type=template&id=56da5554&scoped=true&"
import script from "./AddEditQualityReport.vue?vue&type=script&lang=js&"
export * from "./AddEditQualityReport.vue?vue&type=script&lang=js&"
import style0 from "./AddEditQualityReport.vue?vue&type=style&index=0&id=56da5554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da5554",
  null
  
)

export default component.exports